import { render, staticRenderFns } from "./help-detail.vue?vue&type=template&id=6967c2a6&scoped=true"
import script from "./help-detail.vue?vue&type=script&lang=js"
export * from "./help-detail.vue?vue&type=script&lang=js"
import style0 from "./help-detail.vue?vue&type=style&index=0&id=6967c2a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967c2a6",
  null
  
)

export default component.exports